import { WizardStepName } from "src/app/services/wizard/wizard-step-name.enum";

export class WizardStep {
  name: WizardStepName;
  stepProgressText: string;

  constructor(name: WizardStepName = WizardStepName.Start, stepProgressText: string = "") {
    this.name = name;
    this.stepProgressText = stepProgressText;
  }
}
